import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { TextField as TextField$1 } from '@mui/material';
import { FormControl } from '../form-control/form-control.js';

const TextField = _a => {
  var {
      shrink = undefined,
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mr,
      mt,
      mx,
      my,
      label
    } = _a,
    props = __rest(_a, ["shrink", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "marginY", "mb", "ml", "mr", "mt", "mx", "my", "label"]);
  return jsx(FormControl, Object.assign({
    sx: {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    },
    fullWidth: props.fullWidth,
    size: props.size,
    error: props.error,
    disabled: props.disabled
  }, {
    children: jsx(TextField$1, Object.assign({}, props, {
      InputLabelProps: {
        shrink: shrink ? true : undefined
      },
      label: label
    }))
  }));
};

export { TextField };
